// extracted by mini-css-extract-plugin
export default {"helpDesk":"helpDesk_helpDesk__SvyTg","addTicketBtn":"helpDesk_addTicketBtn__y5oDU"};